// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { pause16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-pause': IconPause;
    }
}

/**
 * The icon component for the 'pause' icon
 */
export class IconPause extends Icon {
    public constructor() {
        super(pause16X16);
    }
}

registerIcon('icon-pause', IconPause);
export const iconPauseTag = 'nimble-icon-pause';
